import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import common from '../../md-search/_store/common';
import { mergeModules } from '@/store/helpers';
import { snapshotSearchStore } from '@/modules/md-snapshot-search/_store';

function initState() {
    return {
        listingSortOptions: [],
        page: 1,
        pageSize: 24,
        sort: null,
        quickSearchState: 0,
        drawing: false,
        loading: true,
        isMapLoading: false,
        searchParams: {},
        mapResult: {},
        selectedHouse: {},
        lastSelectedHouse: null,
        gridOrListType: '',
        mapInited: false,
        marketReport: {},
        prevViewPattern: null,
        averageData: [],
        centerPoint: '',
        zoom: 12,
        property_gathering_amount: 10
    };
}
export default mergeModules(common, snapshotSearchStore, {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
});
